import { render, staticRenderFns } from "./statusDesc.vue?vue&type=template&id=3896cf0e&scoped=true"
import script from "./statusDesc.vue?vue&type=script&lang=js"
export * from "./statusDesc.vue?vue&type=script&lang=js"
import style0 from "./statusDesc.vue?vue&type=style&index=0&id=3896cf0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896cf0e",
  null
  
)

export default component.exports